import { motion } from "framer-motion";

const GenelBaskan = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900">
      {/* Hero Section with Background Image */}
      <div className="relative h-[40vh] bg-black">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url('/images/background-kolektif.jpeg')` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/80" />
      </div>

      {/* Profile Card - Overlapping with Hero */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative -mt-64 bg-gray-900/80 backdrop-blur-xl rounded-2xl shadow-2xl p-8 mb-16 border border-white/10"
        >
          <div className="flex flex-col md:flex-row gap-8">
            {/* Left Side - Image */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="md:w-1/3"
            >
              <img
                src="/team/president/halil-tolga-kaya.png"
                alt="Halil Tolga Kaya"
                className="w-full rounded-xl shadow-2xl ring-4 ring-white/10"
              />
            </motion.div>

            {/* Right Side - Info */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
              className="md:w-2/3"
            >
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-2">
                Halil Tolga Kaya
              </h1>
              <h2 className="text-2xl sm:text-3xl text-blue-400 mb-8">
                Başkan
              </h2>

              <div className="space-y-6 text-gray-300">
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5, duration: 0.5 }}
                >
                  <h3 className="text-white text-lg">Email:</h3>
                  <a
                    href="mailto:tolgaakaya1@gmail.com"
                    className="text-blue-300"
                  >
                    tolgaakaya1@gmail.com
                  </a>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.5 }}
                >
                  <h3 className="   text-white text-lg">Adres:</h3>
                  <p>
                    Esentepe Mah. Büyükdere Cad. Ecza Sok. Pol Center, C Blok
                    No: C16, Levent Şişli/İstanbul
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.7, duration: 0.5 }}
                >
                  <h3 className="   text-white text-lg">
                    Başkanlık Yaptığı Lise:
                  </h3>
                  <p>İelev Özel Lisesi</p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8, duration: 0.5 }}
                >
                  <h3 className="   text-white text-lg">Okuduğu Üniversite:</h3>
                  <p>Münih Üniversitesi, Almanya</p>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* About Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8">
            Hakkında
          </h2>
          <div className="prose max-w-none text-gray-300 space-y-6">
            <p>
              Halil Tolga Kaya, 2023 yılında diğer ortaklarla beraber Kolektif
              Oluşum'u kurmuştur.
            </p>
            <p>
              2023 yılının Ekim ayında %76.64 oyla İelev Özel Lisesi'nde
              Kolektif İelev ile beraber seçim kazanmıştır. 2024 yılının Ekim
              ayında da Kolektif İelev adaylarını destekleyerek İelev'de %60
              oyla seçim kazanmıştır.
            </p>
            <p>
              2024 yılında 7 lisenin daha Kolektif Oluşum'a katılmasında büyük
              rol oynayan Kaya, ortaklarıyla beraber liseler kanadında toplam 13
              lise ile büyük bir atılıma imza atmıştır.
            </p>
            <p>
              2024 yılı itibariyle Münih merkezli olmak üzere Kolektif Avrupa
              projesini hayata geçiren Kaya, şuan Kolektif Oluşum'un genel
              koordinasyonundan sorumludur.
            </p>
          </div>
        </motion.div>

        {/* Timeline Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-12">
            Halil Tolga Kaya'nın Özgeçmişi
          </h2>
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-0 w-0.5 h-full bg-blue-600/30"></div>

            {/* Timeline Items */}
            <div className="space-y-20">
              {/* Porty A.Ş. */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="relative pl-8"
              >
                <div className="absolute left-0 -translate-x-1/2 w-4 h-4 rounded-full bg-blue-600 ring-4 ring-blue-600/30"></div>
                <div className="space-y-4">
                  <div className="   font-bold text-white text-xl">
                    Porty A.Ş.
                  </div>
                  <div className="text-sm text-blue-400">
                    Mayıs 2023 - Aralık 2024
                  </div>
                  <div className="font-medium text-gray-300">
                    Gençlik Departmanı Başkanı
                  </div>
                  <p className="text-gray-400 mt-6">
                    Taşınabilir PowerBank hizmetiyle insanların şarj sorununu
                    çözmeye adanmış dinamik bir kuruluş olan Porty'de, Porty'yi
                    gençlerin yaşamlarını olumlu yönde etkileyen lider bir
                    kuruluş haline getiren ve şirketin gençler arasında
                    tanınmasını sağlayan Gençlik Departmanı'nın başkanlığını
                    üstlendi.
                  </p>
                </div>
              </motion.div>

              {/* Üretken Akademi */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="relative pl-8"
              >
                <div className="absolute left-0 -translate-x-1/2 w-4 h-4 rounded-full bg-blue-600 ring-4 ring-blue-600/30"></div>
                <div className="space-y-4">
                  <div className="   font-bold text-white text-xl">
                    Üretken Akademi
                  </div>
                  <div className="text-sm text-blue-400">
                    Ekim 2022 - Ekim 2023
                  </div>
                  <div className="font-medium text-gray-300">
                    Lise Programları Koordinatörü
                  </div>
                  <p className="text-gray-400 mt-6">
                    Halil Tolga Kaya, teknoloji ve girişimcilik eğitimleri ile
                    bireylerin kariyerlerini geliştirmelerine ve inovatif
                    projeler üretmelerine destek olan Üretken Akademi'de lise
                    programlarını koordine etti.
                  </p>
                </div>
              </motion.div>

              {/* Fenerbahçe SK */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="relative pl-8 pb-8"
              >
                <div className="absolute left-0 -translate-x-1/2 w-4 h-4 rounded-full bg-blue-600 ring-4 ring-blue-600/30"></div>
                <div className="space-y-4">
                  <div className="   font-bold text-white text-xl">
                    Fenerbahçe SK
                  </div>
                  <div className="text-sm text-blue-400">
                    Eylül 2022 - Eylül 2023
                  </div>
                  <div className="font-medium text-gray-300">
                    Gençlik Kulübü Asbaşkanı
                  </div>
                  <p className="text-gray-400 mt-6">
                    5. Olağan Seçimli Fenerbahçe Gençlik Kulübü Genel Kurul
                    Toplantısı'nda Asbaşkan adayı olarak seçime giren ve açık
                    oylama usulüyle gerçekleştirilen seçim sonunda Halil Tolga
                    Kaya, oy çokluğuyla toplam 4000 üyenin bulunduğu Çocuk ve
                    Gençlik Kulübü'nün Asbaşkanı seçildi.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default GenelBaskan;
